export type SlotStart = {
  start_datetime: string;
};

/** Agenda datetimes are wall-clock. The grid may use `T`; the API uses a space. */
export const normalizeWallClockDateTime = (value: string): string => {
  const normalized = value.trim().replace("T", " ").replace("Z", "");

  return normalized.length >= 19 ? normalized.slice(0, 19) : normalized;
};

export const wallClockTimeLabel = (value: string): string =>
  normalizeWallClockDateTime(value).slice(11, 16);

export const findPreferredSlot = <T extends SlotStart>(
  slots: T[],
  preferredStart?: string | null
): T | undefined => {
  if (!preferredStart) {
    return undefined;
  }

  const normalized = normalizeWallClockDateTime(preferredStart);
  const time = wallClockTimeLabel(preferredStart);

  return slots.find((slot) => {
    const slotStart = normalizeWallClockDateTime(slot.start_datetime);

    return slotStart === normalized || slotStart.slice(11, 16) === time;
  });
};

/** Grid click prefills the unit without firing the unit <select> onChange. */
export const shouldLoadUnitCatalog = (
  isOpen: boolean,
  isEditMode: boolean,
  unitId: string
): boolean => isOpen && !isEditMode && unitId.trim() !== "";
